// components/MarkdownWithRouter.jsx
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Link as RouterLink } from 'react-router-dom';
import rehypeRaw from 'rehype-raw';
import { applyNoWrapMacro } from '../utils/nowrap';

// Custom Link Renderer
const LinkRenderer = ({ href, children }) => {
  // Check if the link is an internal link (starts with "/")
  if (href && href.startsWith('/')) {
    return <RouterLink to={href}>{children}</RouterLink>;
  }
  // For external links (including tel:, mailto:, https:, etc.), use the default anchor element
  return <a href={href} rel={href && href.startsWith('http') ? 'noopener noreferrer' : undefined}>{children}</a>;
};

const MarkdownWithRouter = ({ children, className }) => {
  return (
    <ReactMarkdown
      className={className}
      rehypePlugins={[rehypeRaw]}
      components={{
        a: LinkRenderer,
      }}
      urlTransform={(url) => url}
    >
      {applyNoWrapMacro(children)}
    </ReactMarkdown>
  );
};

export default MarkdownWithRouter;
